{"id":"ProductDetail.Info.Name","prefabs":{"default":{"children":[{"component":"ProductDetail.Info.Name","options":"options:*"}]}}}